import { CursorClick, Play, Plus, Heart, ArrowRight, Check, Microphone, MagnifyingGlass } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase, StateLabel } from "../LibraryPrimitives";
import { BloomButton } from "../../styleguide/ui/BloomButton";
import { BloomIconButton } from "../../styleguide/ui/BloomIconButton";

export function ButtonsSection() {
  return (
    <SectionShell
      id="buttons"
      eyebrow="Buttons"
      eyebrowIcon={CursorClick}
      title="Tappable, friendly, unmissable"
      description="Fully-rounded with a gentle spring on hover and press. Every button clears the 48px touch-target minimum, with clear focus rings and calm disabled states."
    >
      <div className="space-y-5">
        <Showcase title="Variants">
          <div className="flex flex-wrap items-center gap-3">
            <BloomButton variant="primary" leftIcon={Play}>Primary</BloomButton>
            <BloomButton variant="secondary">Secondary</BloomButton>
            <BloomButton variant="outline" rightIcon={ArrowRight}>Outline</BloomButton>
            <BloomButton variant="ghost">Ghost</BloomButton>
            <BloomIconButton icon={Plus} variant="primary" label="Add" />
          </div>
        </Showcase>

        <div className="grid gap-5 md:grid-cols-2">
          <Showcase title="Sizes">
            <div className="flex flex-wrap items-center gap-3">
              <BloomButton size="sm">Small</BloomButton>
              <BloomButton size="md">Medium</BloomButton>
              <BloomButton size="lg">Large</BloomButton>
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-3">
              <BloomIconButton icon={Heart} size="sm" label="Like" />
              <BloomIconButton icon={Microphone} size="md" variant="primary" label="Speak" />
              <BloomIconButton icon={MagnifyingGlass} size="lg" variant="outline" label="Search" />
            </div>
          </Showcase>

          <Showcase title="States">
            <div className="grid grid-cols-3 gap-4">
              <div>
                <StateLabel>Default</StateLabel>
                <BloomButton fullWidth>Go</BloomButton>
              </div>
              <div>
                <StateLabel>Pressed</StateLabel>
                <BloomButton fullWidth className="translate-y-0 scale-95 brightness-105">Go</BloomButton>
              </div>
              <div>
                <StateLabel>Disabled</StateLabel>
                <BloomButton fullWidth disabled>Go</BloomButton>
              </div>
            </div>
            <p className="mt-4 text-sm font-semibold text-muted-foreground">Hover &amp; press are live — try the buttons above. Disabled stays calm, never alarming.</p>
          </Showcase>
        </div>

        <Showcase title="Icon buttons">
          <div className="flex flex-wrap items-center gap-3">
            <BloomIconButton icon={Play} variant="primary" label="Play" />
            <BloomIconButton icon={Heart} variant="soft" label="Favourite" />
            <BloomIconButton icon={Check} variant="outline" label="Done" />
            <BloomIconButton icon={Plus} variant="ghost" label="More" />
          </div>
        </Showcase>
      </div>
    </SectionShell>
  );
}

export default ButtonsSection;
